import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  successResponse: {},
  isLoading: false,
  isError: false,
  error: false
};
const compensationRequestSlice = createSlice({
  name: "compensationRequest",
  initialState,
  reducers: {
    compensationRequest: (state, action) => {
      state.isLoading = true;
      state.error = false;
      state.isError = false;
    },
    compensationRequestSuccess: (state, action) => {
      state.isLoading = false;
      state.error = "";
      state.hasData = true;
      state.successResponse = action.payload;
    },
    compensationRequestFailure: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
      state.isError = true;
    },
    clearCompensationRequestData: state => {
      state.error = "";
      state.hasData = false;
      state.successResponse = {};
      state.isError = false;
    }
  }
});
export const {
  compensationRequest,
  compensationRequestSuccess,
  compensationRequestFailure,
  clearCompensationRequestData
} = compensationRequestSlice.actions;
export default compensationRequestSlice.reducer;